import { RouteView } from '@/layouts'

export const overviewRouter = [
  {
    path: '/overview',
    redirect: '/home',
    component: RouteView,
    meta: { title: '概览', keepAlive: true, icon: 'home', ignorePermissions: true,hideInMenu:true ,hidePermissionTree: true,},
    hideChildren: true,
    ignorePermissions: true,//忽略权限控制(忽略的包括里面的所有孩子)
    name:'overview',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home'),
        meta: { title: '首页', keepAlive: true }
      },
      {
        path: '/overview/notification',
        name: 'MessageNotification',
        component: () => import('@/views/overview/MessageNotification'),
        meta: { title: '消息通知', keepAlive: true }
      },
      {
        path: '/overview/dynamics',
        name: 'Dynamics',
        component: () => import('@/views/overview/Dynamics'),
        meta: { title: '最新动态', keepAlive: true }
      }
    ]
  }
]